// src/components/rpa/agent/RpaAgentChatMini.js
//
// Floating chat toggle for the RPA page only.
// Mirrors ChatbotMini.js structure but renders the RPA Agent instead.
// Receives selectedDocId and selectedProjectId from RpaDashboard via props or Redux.

import React, { useState } from 'react';
import { FaRobot } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import RpaAgentChatLogic from './RpaAgentChatLogic';
import './RpaAgentChatMini.css';

const RpaAgentChatMini = ({ selectedDocId, selectedProjectId }) => {
  const [isOpen, setIsOpen] = useState(false);

  // Also try to pull doc/project context from Redux if not passed as props
  const reduxDocId     = useSelector(state => state.rpaAgent?.selectedDocId);
  const reduxProjectId = useSelector(state => state.rpaAgent?.selectedProjectId);

  const docId     = selectedDocId     || reduxDocId;
  const projectId = selectedProjectId || reduxProjectId;

  return (
    <div className={`rpa-agent-mini ${isOpen ? 'open' : ''}`}>
      {/* Toggle button */}
      <button
        className="rpa-agent-toggle"
        onClick={() => setIsOpen(v => !v)}
        title={isOpen ? 'Close Audit Agent' : 'Open Audit Agent'}
      >
        <FaRobot />
        {!isOpen && <span className="rpa-agent-toggle-label">Audit Agent</span>}
        {isOpen  && <span className="rpa-agent-toggle-label">Close</span>}
      </button>

      {/* Chat panel */}
      {isOpen && (
        <div className="rpa-agent-panel">
          <RpaAgentChatLogic
            selectedDocId={docId}
            selectedProjectId={projectId}
            onClose={() => setIsOpen(false)}
          />
        </div>
      )}
    </div>
  );
};

export default RpaAgentChatMini;